import { render, staticRenderFns } from "./common.vue?vue&type=template&id=dc9050e2&scoped=true&"
var script = {}
import style0 from "./common.vue?vue&type=style&index=0&id=dc9050e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9050e2",
  null
  
)

export default component.exports